import { useEffect, useState } from "react";
import "./SecondReport.css";

const QTag = ({ q, a, impacts }) => (
  <div style={{display:'flex',flexWrap:'wrap',gap:'5px 10px',alignItems:'center',background:'#f0f4ff',border:'1px solid #c7d7fa',borderRadius:'6px',padding:'7px 12px',marginBottom:'12px',fontSize:'12px',lineHeight:1.5}}>
    <span style={{background:'#3b5bdb',color:'#fff',fontWeight:700,padding:'2px 8px',borderRadius:4,fontSize:'10px',whiteSpace:'nowrap'}}>📋 FORM QUESTION</span>
    <span style={{color:'#1e3a8a',fontStyle:'italic'}}>"{q}"</span>
    <span style={{color:'#6b7280',fontSize:'11px'}}>→</span>
    <span style={{color:'#047857',fontWeight:700}}>You answered: <strong>{a}</strong></span>
    <span style={{color:'#6b7280',fontSize:'11px'}}>→</span>
    <span style={{color:'#7c3aed',fontSize:'11px'}}>📊 Impacts: {impacts}</span>
  </div>
);

const SecondReport = ({ res }) => {
  const [sectorType, setSectorType] = useState("");
  const [sectorName, setSectorName] = useState("");
  const [aiValue, setAiValue] = useState("");
  const [incubationValue, setIncubationValue] = useState("");

  console.log(incubationValue)
  console.log(aiValue)
  console.log(sectorType)

  useEffect(() => {
    if (!res) return;

    // Clean raw values (remove symbols)
    const cleanedSector = res.sector
    const cleanedAi = res.ai
    const cleanedIncubation = res.incubationFocus

    detectSector(cleanedSector);

    setAiValue(cleanedAi);
    setIncubationValue(cleanedIncubation);
  }, [res]);

  const detectSector = (sector) => {
    const value = sector.toLowerCase().trim();

    setSectorName(sector);

    const primaryKeywords = [
      "agricultural chemicals", "agriculture", "agri-tech", "horticulture",
      "animal husbandry", "dairy farming", "fisheries", "organic agriculture","accounting"
    ];

    const secondaryKeywords = [

      // Added sectors
      "3d printing",
      "apparel",
      "apparel-accessories",
      "auto & truck & manufacturers",
      "auto-vehicles-parts-service-retailers",
      "auto-truck-motorcycle-parts",
      "biotechnology",
      "clean-tech",
      "commodity-chemicals",
      "construction-engineering",
      "construction-materials",
      "construction-supplies-fixtures",
      "diversified-chemicals",
      "drones",
      "electric-vehicles",
      "electronics",
      "embedded",
      "industrial-design",
      "leather-footwear",
      "leather-textiles-goods",
      "manufacture-electrical-equipment",
      "manufacture-machinery-equipment",
      "manufacturing",
      "manufacturing-warehouse",
      "medical-devices-biomedical",
      "microbrewery",
      "non-leather-footwear",
      "non-leather-textiles-goods",
      "oil-gas-drilling",
      "oil-gas-exploration-production",
      "oil-gas-transportation-services",
      "oil-related-services-equipment",
      "physical-toys-games",
      "semiconductor",
      "specialty-chemicals",
      "tires-rubber-products",
      "wearables"
    ];


    const tertiaryKeywords = [

      "adtech",
      "advisory",
      "art",
      "assistance technology",
      "aviation",
      "baby-care",
      "big-data",
      "billing-invoicing",
      "bitcoin-blockchain",
      "bpo",
      "branding",
      "business-finance",
      "business-intelligence",
      "business-support-services",
      "business-support-supplies",
      "clean-technology",
      "coaching",
      "collaboration",
      "commercial-printing-services",
      "comparison-shopping",
      "computer-electronics-retailers",
      "corporate-social-responsibility",
      "coworking-spaces",
      "crowdfunding",
      "customer-support",
      "cxm",
      "cyber-security",
      "data-science",
      "defence-equipment",
      "digital-marketing",
      "digital-media",
      "digital-media-blogging",
      "digital-media-news",
      "digital media publishing",
      "digital-media-video",
      "discovery",
      "e-commerce",
      "e-learning",
      "education-technology",
      "employment-services",
      "enterprise-mobility",
      "entertainment",
      "environmental-services-equipment",
      "erp",
      "event-management",
      "experiential-travel",
      "facility-management",
      "fan-merchandise",
      "fantasy-sports",
      "fashion-technology",
      "food-beverage",
      "food-processing",
      "food-technology-delivery",
      "foreign-exchange",
      "freight-logistics-services",
      "handicraft",
      "health-wellness",
      "healthcare-it",
      "healthcare-services",
      "healthcare-technology",
      "holiday-rentals",
      "home-care",
      "home-furnishings-retailers",
      "home-improvement-products-services",
      "home-security-solutions",
      "homebuilding",
      "hospitality",
      "hotel",
      "housing",
      "insurance",
      "integrated-communication-services",
      "internet-web-services",
      "internships",
      "it-consulting",
      "it-management",
      "it-services",
      "jewellery",
      "kpo",
      "laundry",
      "lifestyle",
      "location-based",
      "loyalty",
      "machine-learning",
      "market-research",
      "marketing-advertising",
      "media-entertainment",
      "mobile",
      "mobile-wallet-payments",
      "movies",
      "natural-language-processing",
      "network-technology-solutions",
      "new-age-construction-technologies",
      "ngo",
      "nlp",
      "online-classified",
      "ooh-media",
      "others",
      "p2p-lending",
      "passenger-transportation-services",
      "payment-platforms",
      "personal-care",
      "personal-finance",
      "personal-security",
      "pharmaceutical",
      "photography",
      "point-of-sales",
      "product-development",
      "professional-information-services",
      "project-management",
      "public-citizen-security-solutions",
      "recruitment-jobs",
      "renewable-energy-solutions",
      "renewable-nuclear-energy",
      "renewable-solar-energy",
      "renewable-wind-energy",
      "restaurants",
      "retail-technology",
      "robotics-application",
      "robotics-technology",
      "sales",
      "scm",
      "skill-development",
      "skills-assessment",
      "smart-home",
      "social-commerce",
      "social-media",
      "space-technology",
      "sports-promotion-networking",
      "talent-management",
      "telecommunications",
      "testing",
      "ticketing",
      "trading",
      "traffic-management",
      "training",
      "transport-infrastructure",
      "transportation",
      "utility-services",
      "virtual-games",
      "waste-management",
      "wayside-amenities",
      "web-design",
      "web-development",
      "weddings",
      "wireless"
    ];


    if (primaryKeywords.some((k) => value.includes(k))) {
      setSectorType("primary");
    } else if (secondaryKeywords.some((k) => value.includes(k))) {
      setSectorType("secondary");
    } else if (tertiaryKeywords.some((k) => value.includes(k))) {
      setSectorType("tertiary");
    } else {
      setSectorType("unknown");
    }
  };

  const sectorData = {
    primary: {
      rank: "🥉",
      sector: "Primary (Agri & Rural)",
      potential: "🌱 Moderate",
      govt: "✅ Moderate (Agri Schemes)",
      investor: "✔️ Moderate (Impact Funds)",
      revenue: "Very High",
    },
    secondary: {
      rank: "🥈",
      sector: "Secondary (Manufacturing)",
      potential: "⚙️ High",
      govt: "✅ High (Make in India)",
      investor: "🔥 High (EV, Robotics)",
      revenue: "High",
    },
    tertiary: {
      rank: "🥇",
      sector: "Tertiary (Tech & Services)",
      potential: "🚀 Very High",
      govt: "✅ Very High (Digital Mission)",
      investor: "🔥🔥 Global",
      revenue: "Medium",
    }
  };

  const selectedData = sectorData[sectorType];
  const formatWord = (word) => {
  if (!word) return "";
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};


  return (
    
    <div style={{ padding: "20px" }}>
      {sectorType === "" ? (
        <p>Loading sector data...</p>
      ) : sectorType === "unknown" ? (
        <p>❌ No matching sector found for: <b>{sectorName}</b></p>
      ) : (
        <>
          <QTag
            q="What sector does your startup operate in? Does it integrate AI, and is it eligible for incubation programs?"
            a={`Sector: ${sectorName} · AI: ${aiValue === "@Yes" ? "Yes" : "No"} · Incubation: ${incubationValue === "!Yes" ? "Yes" : "No"}`}
            impacts="Sector tier classification, startup potential score, govt scheme eligibility, investor preference mapping"
          />
          {/* ==========================
              Sector Table
          =========================== */}
          <div style={{ padding: "12px" }}>
            <table className="final-table-report1">
              <span className="corner-report1 corner-top-left-report1"></span>
              <span className="corner-report1 corner-top-right-report1"></span>
              <span className="corner-report1 corner-bottom-left-report1"></span>
              <span className="corner-report1 corner-bottom-right-report1"></span>

              <thead>
                <tr>
                  <th colSpan="7" className="module2-title-report1">
                     <span className="module-prefix">Module 1:</span>  Idea Intake (Raw Stage)
                  </th>
                </tr>
              </thead>

              <tbody>
                {/* ========= 1A ========= */}
                <tr>
                  <td colSpan="7">
                    <div className="table-scroll-wrapper-report1">
                      <table className="inner-table-report1 idea-intake-table-report1">
                        <thead>
                          <tr>
                            <th>S.NO</th>
                            <th>Rank</th>
                            <th>Sector</th>
                            <th>Startup Potential</th>
                            <th>Govt / Incubation Focus</th>
                            <th>Investor Preference</th>
                            <th>Revenue Potential</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td>1 A</td>
                            <td>{selectedData.rank}</td>
                            <td>{selectedData.sector}</td>
                            <td>{selectedData.potential}</td>
                            <td>{selectedData.govt}</td>
                            <td>{selectedData.investor}</td>
                            <td>{selectedData.revenue}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>

                {/* ========= 1B ========= */}
                <tr>
                  <td colSpan="7">
                    <table className="inner-table-report1">
                      <tbody>
                        <tr>
                          <td>1 B</td>
                          <td>{formatWord(incubationValue === "!Yes" ? "Yes" : "No")}</td>

                          <td colSpan="5">
                            {incubationValue === "!Yes"
                              ? "Fits investor & incubation priorities."
                              : "Not a core incubation-fit sector."}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>

                {/* ========= 1D ========= */}
                <tr>
                  <td colSpan="7">
                    <table className="inner-table-report1">
                      <tbody>
                        <tr>
                          <td>1 D</td>
                          <td>{formatWord(aiValue === "@Yes" ? "Yes" : "No")}</td>

                          <td colSpan="5">
                            {aiValue === "@Yes"
                              ? "Your startup integrates AI capabilities."
                              : "No AI used currently."}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>

                {/* ========= 1C / 1E ========= */}
                <tr>
                  <td colSpan="7">
                    <table className="inner-table-report1">
                      <tbody>
                        <tr>
                          <td>1 C</td>
                          <td rowSpan={2}>{formatWord("Na")}</td>
<td rowSpan={2}>Both values marked as '{formatWord("Na")}'</td>

                        </tr>

                        <tr>
                          <td>1 E</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>

              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default SecondReport;
